import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'

import { 
  getProvider, fetchProvider
} from '../../../store/client'

import { NavigationContext } from '../../../shared/ui/NavigationController'
import Button from '../../../shared/ui/Button'
import Link from '../../../shared/ui/Link'

import ProviderDetailView from '../views/ProviderDetailView'

import { withStyles } from '@material-ui/core/styles'
import LinearProgress from '@material-ui/core/LinearProgress'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import ProviderIcon from '@material-ui/icons/School'

const styles = theme => ({
  root: {
    position: 'relative',
    padding: theme.spacing(2)
  },
  linearProgress: {
    top: 0,
    left: 0,
    position: 'absolute',
    height: '2px',
    overflow: 'hidden',
    width: '100%',
    zIndex: 10
  },
  navigationPanel: {
    //padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
    width: '100%'
  },
  sectionTitle: {
    fontSize: theme.typography.h5.fontSize,
    fontWeight: 800,
    //color: theme.palette.primary.main
  },
  sectionSubtitle: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: 800
  },  
})


const NavigationPanel = ({ theme, classes, provider, openLink }) => {
  return (
    <div elevation={2}
      className={classes.navigationPanel}    
      >
      <Box display='flex' justifyContent='flex-start' alignItems='center'>
        <Box display='flex' flexGrow={1} alignItems='center'>
          <Button 
            icon={ProviderIcon}
            component={Link}
            to="/browse/providers"
            >
            All Training Providers
          </Button>          
        </Box>
        <Box display='flex'>
        </Box>
      </Box>
    </div>
  )
}


const ProviderDetailController = ({ theme, classes, ...props }) => {

  const { providerKey, isFetching, lastFetched, data } = props
  
  const navigationContext = useContext(NavigationContext)

  useEffect(() => {
    // ProviderDetailView will start all the fetching.
  }, [])  
      
  return (
    <div className={classes.root}
      >      
      { false && isFetching &&
        <div className={classes.linearProgress}>
          <LinearProgress />
        </div>
      }      
      
      <Container maxWidth='md'>
        <Box mt={0}>
          <NavigationPanel theme={theme} classes={classes} provider={data}
          openLink={(link) => navigationContext.openLink(link)}
            />
        </Box>
        <Box mt={4}>
          <ProviderDetailView
            providerKey={providerKey}
            />          
        </Box>
        <Box mt={10} />
      </Container>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  let providerKey = ownProps.match.params.providerKey

  return {
    providerKey,
    ...getProvider(state,providerKey)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  let providerKey = ownProps.match.params.providerKey
    
  return {
    fetchProvider:() => {
      dispatch(fetchProvider(providerKey, true, null))
    }
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(ProviderDetailController)
)
